import { render, staticRenderFns } from "./LabelLink.vue?vue&type=template&id=dee46412&"
import script from "./LabelLink.vue?vue&type=script&lang=js&"
export * from "./LabelLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports